// Simpleicons slugs that return HTTP 404 on cdn.simpleicons.org (trademark
// removals or slugs that never existed). Single source of truth — both the
// marketplace catalogue merger and the canvas integration data-processing
// helpers consume this. Any DB `icon` value in this set is treated as
// absent so the letter-initials chip / glyph renders instead of a broken
// <img>.
export const SIMPLEICONS_404 = new Set([
  'amazonwebservices', // aws — removed from simpleicons
  'amazons3', // aws_s3 — removed
  'openai', // removed
  'slack', // removed
  'twilio', // removed
  'sendgrid', // removed
  'segment', // removed
  'linkedin', // removed (trademark — workspace bug #2190)
  'workos', // never in simpleicons
  'pinecone', // never in simpleicons
  'logrocket', // never in simpleicons
  'uploadthing', // never in simpleicons
  'server', // generic name, not in simpleicons (custom_http placeholder)
  'mic', // generic name, not in simpleicons (livekit placeholder)
  'database', // generic name, not in simpleicons (legacy integration rows ship it)
  'ai' // generic name, not in simpleicons (openai placeholder)
])

// Sanitise a raw icon slug from the DB before using it as a simpleicons src.
// Returns null when the slug is absent, blank, the string "undefined", or in
// the known-404 denylist — so callers can safely test `if (safeSlug)`.
export const sanitiseIconSlug = (raw) => {
  if (!raw || raw === 'undefined' || raw === 'null') return null
  return SIMPLEICONS_404.has(raw) ? null : raw
}
